import TimeSlots from './time-slots';

export default TimeSlots;